import styled from 'styled-components'
import { mediaMax, calculateResponsiveSize } from 'styles/media-queries'
import { colors } from 'styles/global-styles'
import IcoClose from 'icons/ico_close.svg'

export const Wrapper = styled.div`
  .cookies-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${calculateResponsiveSize(8)} ${calculateResponsiveSize(60)};
    font-family: 'Gotham';
    font-size: ${calculateResponsiveSize(10)};
    color: ${colors.sand};
    font-weight: 400;
    line-height: 1.4;
    background: ${colors.noir};
    opacity: 0;
    visibility: hidden;
    transform: translateY(150%);
    transition: opacity 1.25s, transform 1.25s;
    z-index: 1000;
  }
  &.show {
    .cookies-banner {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
  .cookies-banner-accept-btn {
    display: none;
  }

  ${mediaMax('mobile')} {
    .cookies-banner {
      padding: ${calculateResponsiveSize(9)} ${calculateResponsiveSize(60)} ${calculateResponsiveSize(12)} ${calculateResponsiveSize(20)};
    }
  }
`

export const Content = styled.div``

export const ButtonClose = styled.div`
  position: absolute;
  top: 50%;
  right: ${calculateResponsiveSize(20)};
  width: ${calculateResponsiveSize(19)};
  height: ${calculateResponsiveSize(12)};
  background: url(${IcoClose}) center center no-repeat;
  background-size: auto 100%;
  transform: translateY(-50%);
  transition: transform 0.25s;
  cursor: pointer;
  &:hover {
    transform: translateY(-50%) scale(1.15);
  }
`
